import React from 'react';
import Box from '@mui/material/Box';

interface TabPanelProps {
  children?: React.ReactNode;
  value: string;
  selected: string;
  className?: string;
}

/**
 * Custom TabPanel component that ensures proper HTML structure
 * by using div elements instead of paragraph elements
 */
export const CustomTabPanel = (props: TabPanelProps) => {
  const { children, selected, value, className, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={selected !== value}
      id={`tabpanel-${value}`}
      aria-labelledby={`tab-${value}`}
      className={className}
      {...other}
    >
      {selected === value && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
};